import { AbstractControl, AbstractControlOptions, ValidationErrors, ValidatorFn } from '@angular/forms';

import { EditorBookingItemSetting } from './editor-booking-item-setting.model';
import { EditorDataService } from '../editor-data/editor-data.service';


const settingValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (control.pristine) {
    return null;
  }

  return control.get('id').value !== '' ? null : { invalidId: true };
};


export class EditorBookingItemSettingVenue extends EditorBookingItemSetting {
  settingClassName = 'Venue';
  serializedName = 'venue';
  showSummary = true;

  id: string;

  constructor(obj?: any) {
    super({
      inheritableType: obj?.inheritableType ?? null
    });
    this.id = obj?.id ?? null;
  }

  createCopy(): EditorBookingItemSettingVenue {
    return new EditorBookingItemSettingVenue({
      id: this.id,
      inheritableType: this.inheritableType
    });
  }

  getTitle(): string {
    return $localize `Venue`;
  }

  getHelpText(): string {
    return $localize `At which venue is this occurring?`;
  }

  hasSummary(): boolean {
    return this.id !== null;
  }

  getIdAsString(venueNames: { id: string, name: string }[]): string {
    if (this.id === null) { return ''; }
    return venueNames
      .find(venueName => venueName.id === this.id)?.name ?? $localize `Not valid`;
  }

  getFormConfig(_editorData: EditorDataService): {
    controlsConfig: { [key: string]: any; },
    options?: AbstractControlOptions
  } {
    return {
      controlsConfig: { id: [this.id] },
      options: {
        validators: settingValidator
      }
    };
  }

  getFormValues(): any {
    return { id: this.id };
  }

  getEmptyFormValues(): any {
    return { id: null };
  }

  applyFormValues(formValues: any) {
    this.id = formValues.id;
  }

  getSerializedValues(): any {
    return {
      venue: this.id
    };
  }
}
